export default {
    // 获取
    getLocalStorage(key) {
        return localStorage.getItem(key);
    },
    // 存储
    setLocalStorage(key, value) {
        return localStorage.setItem(key, value);
    },

    // 删除
    delLocalStorage(key) {
        return localStorage.removeItem(key);
    }
    // // 获取并且转化
    // getObjLocalStorage(key) {
    //     return JSON.parse(localStorage.getItem(key));
    // }
}